import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
export type ModalProp = {
  children: React.ReactNode;
  open: boolean;
  toggle: (isOpen?: boolean) => void;
  closeOnClickOutside: boolean;
  updateFlg?: boolean;
};

export const Modal = ({
  open,
  toggle,
  children,
  closeOnClickOutside,
  updateFlg = false,
}: ModalProp) => {
  // useEffect(() => {
  //   const handleOutsideClick = (event: any) => {
  //     if (closeOnClickOutside && !ref.current?.contains(event.target)) {
  //       if (!open) return;
  //       toggle(false);
  //     }
  //   };
  //   window.addEventListener('click', handleOutsideClick);
  //   return () => window.removeEventListener('click', handleOutsideClick);
  // }, [closeOnClickOutside, open, ref, toggle,]);

  // close modal when you click on "ESC" key
  // useEffect(() => {
  //   const handleEscape = (event:any) => {
  //     if (!open) return;
  //     if (event.key === 'Escape') {
  //       toggle(false);
  //     }
  //   };
  //   document.addEventListener('keyup', handleEscape);
  //   return () => document.removeEventListener('keyup', handleEscape);
  // }, [ open, toggle]);

  return (
    //マウス操作で閉じないようにボタンクリックイベントのみを有効
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" static className="relative z-10" onClose={() => null}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-400"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              {children}
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

type titleProps = {
  mainTitle: string;
  subTitle: string;
};
export const ModalTitle = ({ mainTitle, subTitle }: titleProps) => {
  return (
    <Dialog.Title
      as="h3"
      className="text-left text-lg font-medium leading-6 text-gray-900"
    >
      <div className="mt-8 text-left">
        <h3 className="text-lg font-medium leading-6 text-gray-800">
          {mainTitle}
        </h3>
        <p className="mt-1 text-sm text-gray-500">{subTitle}</p>
      </div>
    </Dialog.Title>
  );
};
